import { cloneDeep } from 'lodash-es';
import { ScheduleAvailabilityTypes as Types } from '@frontend/api-schedule-availability';
import { FormFieldActionTypes, useForm } from '@frontend/design-system';
import { getAvailabilityHoursFormFields } from '../helpers';
import { AvailabilityHoursFormConfig } from '../types';

const DEFAULT_WORKING_HOURS_RANGE = {
  value: ['09:00:00', '17:00:00'],
  displayValue: ['9:00am', '5:00pm'],
};

export const useAvailabilityHoursForm = () => {
  const form = useForm<AvailabilityHoursFormConfig, keyof AvailabilityHoursFormConfig>({
    fields: getAvailabilityHoursFormFields(),
    fieldStateReducer: (state, action) => {
      if (action.type === FormFieldActionTypes.Update && action.payload.name.endsWith('-checkbox')) {
        const day = action.payload.name.split('-')[0] as Types.Weekday;
        // Reset time range when checkbox is unchecked
        if (!action.payload.value) {
          return {
            ...state,
            [`${day}-time-range`]: { ...state[`${day}-time-range`], value: ['', ''] },
          };
        } else {
          // set default time range if checkbox is checked
          return {
            ...state,
            [`${day}-time-range`]: {
              ...state[`${day}-time-range`],
              ...cloneDeep(DEFAULT_WORKING_HOURS_RANGE),
            },
          };
        }
      }
      return state;
    },
  });

  return form;
};
